import { render, staticRenderFns } from "./TabGridSeleccion.vue?vue&type=template&id=29d0a7ca&"
import script from "./TabGridSeleccion.vue?vue&type=script&lang=ts&"
export * from "./TabGridSeleccion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29d0a7ca', component.options)
    } else {
      api.reload('29d0a7ca', component.options)
    }
    module.hot.accept("./TabGridSeleccion.vue?vue&type=template&id=29d0a7ca&", function () {
      api.rerender('29d0a7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/TabGridSeleccion.vue"
export default component.exports